var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.021 11.707C18.1608 11.5671 18.256 11.389 18.2945 11.195C18.3331 11.0011 18.3133 10.8 18.2376 10.6173C18.162 10.4346 18.0338 10.2785 17.8694 10.1686C17.705 10.0587 17.5117 10 17.314 10H10.314V12H14.9L10.607 16.293C10.4672 16.4329 10.3719 16.611 10.3334 16.805C10.2948 16.9989 10.3146 17.2 10.3903 17.3827C10.466 17.5654 10.5941 17.7215 10.7585 17.8314C10.9229 17.9413 11.1162 18 11.314 18H18.314V16H13.728L18.021 11.707ZM5.31396 0.99H3.31396V12.99H0.313965L4.31396 16.99L8.31396 12.99H5.31396V0.99ZM15.314 0H13.314C12.897 0 12.524 0.259 12.377 0.649L9.62696 7.982H11.764L12.507 6H16.12L16.863 7.981H19L16.25 0.648C16.1784 0.457613 16.0504 0.293588 15.8832 0.177808C15.7159 0.062028 15.5174 0 15.314 0ZM13.257 4L14.007 2H14.62L15.37 4H13.257Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.46956f0893c54a866dc82e5451b1e66b.svg";
export { ForwardRef as ReactComponent };